import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

import { TwoFactorAuthenticationApi } from "../../services";

/**
 * @author Atish Bagate
 */
export const useDisable2FA = () => {
  return useMutationWithLoading(async (params: { email: string, password: string, xTENANTID?: string }) => {
    const response = await new TwoFactorAuthenticationApi(getConfigObject()).disable2FA(
        params.email,
        params.password,
        params.xTENANTID
    );
    return response;
  });
};